import { useEffect, type ReactNode } from 'react';

export function Modal({
  title,
  onClose,
  footer,
  children,
}: {
  title: string;
  onClose: () => void;
  footer?: ReactNode;
  children: ReactNode;
}) {
  useEffect(() => {
    const onKey = (event: KeyboardEvent): void => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      className="modale"
      role="dialog"
      aria-modal="true"
      aria-label={title}
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className="modale__panneau">
        <div className="modale__entete">
          <h2>{title}</h2>
          <button
            type="button"
            className="bouton bouton--fantome bouton--petit"
            onClick={onClose}
            aria-label="Fermer"
          >
            Fermer
          </button>
        </div>
        <div className="modale__corps">{children}</div>
        {footer !== undefined && <div className="modale__pied">{footer}</div>}
      </div>
    </div>
  );
}
